import React, { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";

import { renderWithBreaks } from '@utils/translations';
import styles from "@components/cancellationPoliciesPage/timelines/timeline.module.scss";

const TimelineFlexible = () => {
  const intl = useIntl();

  return (
    <Fragment>
      <h1>
        {intl.formatMessage({ id: 'Flexible' })} -{' '}
        <em>{intl.formatMessage({ id: 'Full 1st rent\'s payment refund up to 30 days prior to contract start' })}</em>
      </h1>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Timeline Flexible text' }), 'li')}</ul>
      <div className={styles.timeline}>
        <div
          className={clsx(
            styles.timeline__amount,
            styles.timeline__amountRefundGreen
          )}
          style={{ width: '40%' }}
        >
          <div>
            <FormattedMessage id={'100% refund of 1st rent\'s payment'} />
            <span className={styles.timeline__numberDays}>
              <FormattedMessage id={'Up to'} />:
              <strong>
                30 <FormattedMessage id={'days'} />
              </strong>
            </span>
          </div>
        </div>
        <div
          className={clsx(
            styles.timeline__amount,
            styles.timeline__amountRefundOrange
          )}
          style={{ width: '30%' }}
        >
          <FormattedMessage id={'50% refund of 1st rent\'s payment'} />
          <span className={styles.timeline__numberDays}>
            <FormattedMessage id={`Up to`} />:{' '}
            <strong>
              15 <FormattedMessage id={'days'} />
            </strong>
          </span>
        </div>
        <div
          className={clsx(
            styles.timeline__amount,
            styles.timeline__amountRefundRed
          )}
          style={{ width: '30%' }}
        >
          <FormattedMessage id={'No refund'} />
          <span className={styles.timeline__numberDays}>
            <FormattedMessage id={'Up to'} />:{' '}
            <strong>
              <FormattedMessage id={'Contract start'} />
            </strong>
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default TimelineFlexible;
